import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_PURCHASE_ORDER_TOTALS_KEY } from '@/keys';
import type { PurchaseOrderTotals } from '@/types/core/purchase-order/purchase-order-totals';

export const getPurchaseOrderTotals = async (
  id: string,
): Promise<PurchaseOrderTotals> => {
  const response = await api.get<PurchaseOrderTotals>(
    `/purchase-orders/${id}/totals`,
  );
  return response.data;
};

export const useGetPurchaseOrderTotals = (
  id: string,
): UseSuspenseQueryResult<PurchaseOrderTotals, Error> =>
  useSuspenseQuery({
    queryKey: [...GET_PURCHASE_ORDER_TOTALS_KEY, id],
    queryFn: () => getPurchaseOrderTotals(id),
  });
